import GraphEditorChromeSlot from "./GraphEditorChromeSlot.jsx";
import React from "react";
import { Plus, Minus, Maximize } from "lucide-react";
export const MAP_ZOOM_STEP = 1.2;
export default function MapViewportControls({
  onZoomIn,
  onZoomOut,
  onFit,
  className = "",
}) {
  return (
    <GraphEditorChromeSlot name="zoom"><div
      className={`react-flow__controls nodrag nopan km-viewport-controls absolute bottom-4 left-4 z-10 flex flex-col overflow-hidden rounded-md border border-[#d9dde0] bg-white shadow-md ${className}`}
      role="group"
      aria-label="Map Controls"
    >
      {[
        ["Zoom in", onZoomIn, Plus],
        ["Zoom out", onZoomOut, Minus],
        ["Fit map to available canvas", onFit, Maximize],
      ].map(([label, action, Icon], index) => (
        <button
          key={label}
          type="button"
          onClick={action}
          aria-label={label}
          title={label}
          className={`react-flow__controls-button grid h-8 w-8 place-items-center text-[#52565b] hover:bg-[#f2f3f4] ${index < 2 ? "border-b border-[#e5e7e9]" : ""}`}
        >
          <Icon size={16} />
        </button>
      ))}
    </div></GraphEditorChromeSlot>
  );
}
